import { atom } from 'jotai';
import { OutTaskboxDetailResponse } from 'queries/model';
export const focusModeTaskboxAtom = atom<OutTaskboxDetailResponse | null>(null);
export const hideFocusModeTaskboxAtom = atom<boolean>(false);
